document.addEventListener('DOMContentLoaded', function () {
  // Run only on product pages
  if (!window.location.pathname.includes('/products/')) return;

  // Listen for the acpa_field_updated event
  document.addEventListener('acpa_field_updated', function (event) {
    try {
      // Ensure required values exist
      let compareAtPrice = Number(window.aco_product?.compare_at_price || 0);
      compareAtPrice = compareAtPrice/100;
      const optionPrice = Number(event?.detail?.price?.option || 0);
      // Calculate new total
      const total = compareAtPrice + optionPrice;
      const newTotal = formatMoney(total*100, window.aco_shopCurrencyFormat);

      // Select target price element
      const priceElement = document.querySelector('.price__sale s.price-item.price-item--regular');

      // Update price content
      if (priceElement) {
        priceElement.textContent = newTotal;
      } else {
        console.warn('Price element not found: .price__sale s.price-item.price-item--regular');
      }
    } catch (error) {
      console.error('Error updating price:', error);
    }
  });
});

/**
 * Function to format money by using current stores money format
 *
 * @param {number} money Money to format
 * @param {string} type Whether it is a line price or total price
 * @returns
 */
const formatMoney = (cents, format) => {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  // var formatString = format || this.money_format;
  let formatString = format || '${{amount}}';

  function defaultOption(opt, def) {
    return typeof opt == 'undefined' ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    let parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 2, ' ', '.');
      break;
    case 'amount_no_decimals_with_period_and_space_separator':
      value = formatWithDelimiters(cents, 0, ' ', '.');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  return formatString.replace(placeholderRegex, value);
};